module.exports = __webpack_public_path__ + "img/business-icon2-click.95fd29a8.png";